import { usePostAppDigiplaceDigiplacecancelableInvoke } from '@/api/digiplace/digiplace';
import { useAuth } from '@/hooks/useAuth';

import ModalRenonciationError from './components/ModalRenonciationError';
import ModalRenonciationInitial from './components/ModalRenonciationInitial';
import ModalRenonciationSuccess from './components/ModalRenonciationSuccess';

interface ContentModalRenonciationProps {
  nomProduit: string;
  placementId: string;
  delayDays: number;
  onClose: () => void;
  onSuccess: () => void;
}

const ContentModalRenonciation = ({
  nomProduit,
  placementId,
  delayDays,
  onClose,
  onSuccess,
}: ContentModalRenonciationProps) => {
  const { user } = useAuth();
  const { mutate: submitRenunciation, isPending, isError, isSuccess } = usePostAppDigiplaceDigiplacecancelableInvoke();

  const handleConfirm = () => {
    if (!user?.nom || !user?.prenom || !user?.email) return;
    const data = {
      nom: user.nom,
      prenom: user.prenom,
      placement: nomProduit,
      email: user.email,
      ...(placementId ? { ficheSf: placementId } : {}),
    };
    submitRenunciation({
      data,
    });
  };

  const isRetractation = delayDays === 14;

  if (isSuccess) {
    return <ModalRenonciationSuccess isRetractation={isRetractation} onSuccess={onSuccess} onClose={onClose} />;
  }

  if (isError) {
    return (
      <ModalRenonciationError
        nomProduit={nomProduit}
        isRetractation={isRetractation}
        onRetry={handleConfirm}
        onClose={onClose}
      />
    );
  }

  return (
    <ModalRenonciationInitial
      nomProduit={nomProduit}
      delayDays={delayDays}
      isPending={isPending}
      isConfirmDisabled={!user?.nom || !user?.prenom || !user?.email}
      onConfirm={handleConfirm}
      onClose={onClose}
    />
  );
};

export default ContentModalRenonciation;
